import {createAction, handleActions} from "redux-actions";

const SET_MENU_DATA = 'menu/SET_MENU_DATA';
const CHANGE_STATE = 'menu/CHANGE_STATE';
const SET_HIDDEN = 'menu/SET_HIDDEN';
const SET_MENU_ITEM = 'menu/SET_MENU_ITEM';

export const setMenuData = createAction(SET_MENU_DATA, menu => menu);
export const changeState = createAction(CHANGE_STATE, ({key, isChecked}) => ({
    key,
    isChecked
}));
export const setHidden = createAction(SET_HIDDEN, ({key, hide}) => ({
    key,
    hide
}));
export const setSelectedItem = createAction(SET_MENU_ITEM, selectedMenuItem => selectedMenuItem);

const initialState = {
    menu: null,
    selectedMenuItem: 'AGREE_0'
};

const menu = handleActions(
    {
        [SET_MENU_DATA]: (state, action) => ({
            ...state,
            menu: action.payload
        }),
        [CHANGE_STATE]: (state, action) => ({
            ...state,
            menu: {
                ...state.menu,
                [action.payload.key]: {
                    ...state.menu[action.payload.key],
                    isChecked: action.payload.isChecked
                }
            }
        }),
        [SET_HIDDEN]: (state, action) => ({
            ...state,
            menu: {
                ...state.menu,
                [action.payload.key]: {
                    ...state.menu[action.payload.key],
                    hide: action.payload.hide
                }
            }
        }),
        [SET_MENU_ITEM]: (state, action) => ({
            ...state,
            selectedMenuItem: action.payload
        })
    },
    initialState
);

export default menu;